module.exports = __webpack_public_path__ + "img/stock-2.a30cd406.jpg";